import {
  Autocomplete, Box, FormControlLabel, IconButton, Radio, RadioGroup, Table,
  TableBody, TableCell, TableHead, TableRow, TextField, Tooltip, Typography,
  Accordion, AccordionSummary, AccordionDetails
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg'
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import { COMMON_STYLE, Intensity_Level } from '../../../../Utility/Constants';
import DeleteIcon from '@mui/icons-material/Delete';
import ShowComponents from '../../DoctorNotes/Common/ShowComponent';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import { useDebounce } from '../../../../Components/Common Components/CommonComponents';
import PrintIcon from '@mui/icons-material/Print';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';


const investState = {
  patientId: '',
  appointmentId: '',
  clinicId: '',
  doctorId: '',
  investigationData: [],
  selectedRadio: 'test',
  labList: [],
  labTestData: [],
  specialData: [],
  selectedLabName: null,
  printLoad: false,
  dupInvestogationData: '[]'
}

const UmaInvestigation = React.forwardRef((props, ref) => {
  const [invest, setInvest] = useState(investState)
  const [search, setSearch] = useState('')
  const debounceQuery = useDebounce(search, 500)
  const [message, setMessage] = useState({
    isErrorMsgText: '',
    successMsgText: '',
    isErrorMsg: false,
    successMsg: false,
  })

  React.useImperativeHandle(ref, () => ({
    performInvestigationAction: () => {
      let investData = JSON.stringify(invest.investigationData)
      if (investData !== invest.dupInvestogationData) {
        postInvestigationData()
      }
    }
  }))

  const errorMessage = (message) => {
    setMessage({
      ...message,
      isErrorMsg: true,
      isErrorMsgText: `${message} - INVESTIGATION`,
    })
  }

  const successMessage = (message) => {
    setMessage({
      ...message,
      successMsg: true,
      successMsgText: `${message} - INVESTIGATION`,
    })
  }

  const msgClose = () => {
    setMessage({
      ...message,
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }

  useEffect(async () => {
    if (debounceQuery) {
      await getSpecialTestSearch(debounceQuery)
    } else {
      setInvest((prev) => ({
        ...prev, specialData: []
      }))
    }
  }, [debounceQuery])

  useEffect(() => {
    if (invest.printLoad) {
      getInvestigationPrint()
    }
    if (invest.labList?.length > 0) {
      getInvestigationData()
    }else{
      setInvest((prev) => ({
        ...prev,
        investigationData:[{ is_transmitted: false, test_type: '', lab_name: '', lab_id: '', test_name: '', test_id: '', id: null, status: 'Inprogress' }]
      }))
    }
  }, [invest.printLoad, invest.labList])

  const apicalls = async () => {
    await getLabTestData()
  }

  const getLabTestData = async () => {
    try {
      const response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_INVESTIGATION_LAB_TEST + '?clinic_id=' + props?.props?.clinic_id + '&doctor_id=' + props?.props?.doctorID)
      if (response?.data?.status === 'success') {
        let dataList = response?.data?.data
        setInvest((prev) => ({
          ...prev,
          labList: dataList
        }))
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error?.response?.data?.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const getSpecialTestSearch = async (search) => {
    try {
      const response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_INVESTIGATION_SPECIAL_SEARCH + '?search=' + search + '&doctor_id=' + props?.props?.doctorID)

      if (response?.data?.status === 'success') {
        setInvest((prev) => ({
          ...prev,
          specialData: response?.data?.data
        }))
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error?.response?.data?.message)
      } else {
        errorMessage(error.message)
      }
    }
  }


  const getInvestigationData = async () => {
    try {
      const response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_INVESTIGATION +
        '?appointment_id=' + props?.props?.appointment_id + '&patient_id=' + props?.props?.patient_id + '&doctor_id=' + props?.props?.doctorID
      )
      if (response?.data?.status === 'success') {
        let investData = Object.keys(response?.data?.data)?.length > 0 ? response?.data?.data : {}
        let testDatas = [];
        Object.keys(investData)?.length > 0 && investData?.investigation?.forEach(element => {
          testDatas?.push({
            lab_name: invest.labList?.length === 1 ? invest.labList[0]?.laboratory_name : element?.laboratory_name,
            lab_id: invest.labList?.length === 1 ? invest.labList[0]?.laboratory_id : element?.transmitted_laboratory_id,
            test_name: element?.test_name || element?.special_test_name,
            test_id: element?.lab_set_new_id || element?.lab_test_new_id || element?.package_id || element?.test_id,
            status: element?.status ? element.status : 'Inprogress',
            id: element?.id ? element?.id : null,
            test_type: element?.lab_set_new_id ? 'Group' : element?.lab_test_new_id ? 'Test' : element?.package_id ? 'Package' : 'special',
            is_transmitted: element?.is_transmitted ? element?.is_transmitted : false
          })
        })
        let obj = { is_transmitted: false, test_type: '', lab_name: invest.labList?.length === 1 ? invest.labList[0]?.laboratory_name : '', lab_id: invest.labList?.length === 1 ? invest.labList[0]?.laboratory_id :'', test_name: '', test_id: '', id: null, status: 'Inprogress' }
        setInvest((prev) => ({
          ...prev,
          investigationData: Object.keys(investData)?.length > 0 ? [...testDatas, obj] : [obj],
          dupInvestogationData: Object.keys(investData)?.length > 0 ? JSON.stringify([...testDatas, obj]) : JSON.stringify([obj]),
          labTestData:invest.labList?.length === 1 ? invest.labList[0]?.test_detail : []
        }))
        props.setAccordionOpen(testDatas?.length > 0);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error?.response?.data?.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const getInvestigationPrint = async () => {
    try {
      const response = await RestAPIService.getAllPrint(Serviceurls.NEW_DOC_NOTES_INVESTIGATION +
        '?appointment_id=' + props?.props?.appointment_id + '&patient_id=' + props?.props?.patient_id + '&export_type=pdf' + '&doctor_id=' + props?.props?.doctorID
      )
      if (response) {
        const file = new Blob(
          [response.data],
          { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
        setInvest((prev) => ({ ...prev, printLoad: false }))
      }
    } catch (error) {
      setInvest((prev) => ({ ...prev, printLoad: false }))
      if (error?.response?.data?.message) {
        errorMessage(error.response?.data?.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const postInvestigationData = async () => {
    try {
      let investigationList = [];
      invest.investigationData?.filter(item => item?.test_name !== '')?.forEach(element => {
        investigationList?.push({
          id: element?.id ? element?.id : null,
          package_id: element?.test_type === "Package" ? element?.test_id : null,
          lab_set_new_id: element?.test_type === "Group" ? element?.test_id : null,
          lab_test_new_id: element?.test_type === "Test" ? element?.test_id : null,
          test_name: element?.test_type !== 'special' ? element?.test_name : '',
          test_id: element?.test_type === 'special' ? element?.test_id : null,
          special_test_name: element?.test_type === 'special' ? element?.test_name : '',
          transmitted_laboratory_id: element?.lab_id ? element?.lab_id : null
        })
      })
      let data = {
        appointment_id: props?.props?.appointment_id,
        investigation: investigationList
      }
      const response = await RestAPIService.create(data, Serviceurls.NEW_DOC_NOTES_INVESTIGATION)
      if (response?.data?.status === 'success') {
        successMessage(response.data?.message)
        await getInvestigationData()
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error?.response?.data?.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const postInvestigationTransmitData = async () => {
    try {
      let transmitData = [];
      invest?.investigationData?.filter(item => item?.test_name !== '')?.forEach(element => {
        transmitData?.push({
          id: element?.id || null,
          is_transmitted: element?.is_transmitted || false,
          transmitted_laboratory_id: element?.lab_id || null
        })
      })
      let data = {
        appointment_id: props?.props?.appointment_id,
        patient_id: props.props?.patient_id,
        line_item_ids: transmitData
      }
      const response = await RestAPIService.create(data, Serviceurls.DOC_DOCTOR_NOTES_TEST_TRANSMIT)
      if (response?.data?.status === 'success') {
        successMessage(response?.data?.message)
        await getInvestigationData()
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error?.response?.data?.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const deleteInvestigationData = async (item, index) => {
    try {
      if (item.id) {
        let data = { id: item?.id }
        const response = await RestAPIService.delete(Serviceurls.NEW_DOC_NOTES_INVESTIGATION, data)
        if (response.data.status === 'success') {
          successMessage(response.data.message)
          await getInvestigationData()
        }
      } else {
        let investigationData = [...invest.investigationData]
        setInvest((prev) => {
          if (index !== (invest.investigationData?.length - 1)) {
            investigationData?.splice(index, 1)
          } else {
            investigationData[index] = { is_transmitted: false, test_type: '', lab_name: invest.labList?.length === 1 ? invest.labList[0]?.laboratory_name : '', lab_id: invest.labList?.length === 1 ? invest.labList[0]?.laboratory_id : '', test_name: '', test_id: '', id: null, status: 'Inprogress' }
          }
          return { ...prev, investigationData,labTestData:invest.labList?.length === 1 ? invest.labList[0]?.test_detail : [] }
        })
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error?.response?.data?.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const onChangeHandler = (newValue, key, index) => {
    try {
      let investigation = [...invest.investigationData];
      switch (key) {
        case 'lab_name':
          investigation[index] = {
            ...investigation[index],
            lab_name: newValue?.laboratory_name || '',
            lab_id: newValue?.laboratory_id || ''
          };
          setInvest((prev) => ({ ...prev, investigationData: investigation, labTestData: newValue?.test_detail || [] }))
          break;
        case 'test_name':
          investigation[index] = {
            ...investigation[index],
            test_name: newValue?.test_name || '',
            test_type: newValue?.test_type || '',
            test_id: newValue?.id || ''
          };
          if (newValue && index === investigation.length - 1) {
            investigation.push({ is_transmitted: false, test_type: '', lab_name: invest.labList?.length === 1 ? invest.labList[0]?.laboratory_name : '', lab_id: invest.labList?.length === 1 ? invest.labList[0]?.laboratory_id : '', test_name: '', test_id: '', id: null, status: 'Inprogress' });
          }
          setInvest((prev) => ({ ...prev, investigationData: investigation,labTestData:invest.labList?.length === 1 ? invest.labList[0]?.test_detail : [] }))
          break;
        case 'special_test_name':
          investigation[index] = {
            ...investigation[index],
            test_name: newValue?.name || newValue || '',
            test_type: 'special' || '',
            test_id: newValue?.id || ''
          };
          if (newValue && index === investigation.length - 1) {
            investigation.push({ is_transmitted: false, test_type: '', lab_name: invest.labList?.length === 1 ? invest.labList[0]?.laboratory_name : '', lab_id: invest.labList?.length === 1 ? invest.labList[0]?.laboratory_id : '', test_name: '', test_id: '', id: null, status: 'Inprogress' });
          }
          setInvest((prev) => ({ ...prev, investigationData: investigation,labTestData:[] }))
          break;
      }
    } catch (error) {
      errorMessage(error.message)
    }
  }


  const autocompleteTextBox = (names, values, options = [], optionLabel, placeholders, index) => {
    try {
      return (
        <Autocomplete
          disabled={props?.props?.patient_transfered || props?.props?.isLocked || invest.investigationData[index]['is_transmitted']}
          clearIcon
          freeSolo={invest.selectedRadio === 'special' ? true : false}
          size='small'
          sx={{ width: '13dvw' }}
          value={values}
          options={options}
          getOptionLabel={(option) => typeof (option) === 'string' ? option : option[optionLabel]}
          onChange={(e, newValue) => { onChangeHandler(newValue, names, index) }}
          onInputChange={(e, newValue) => {
            if (invest.selectedRadio === 'special') {
              onChangeHandler(newValue, names, index)
            }
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder={placeholders}
              InputProps={{
                ...params.InputProps, emed_tid: names,
                style: { height: COMMON_STYLE.HEIGHT, padding: COMMON_STYLE.PADDING }
              }}
              onChange={(e) => {
                let value = e.target.value
                if (invest.selectedRadio === 'special') {
                  setSearch(value)
                }
              }}
            />
          )}
        />
      )
    } catch (error) {
      errorMessage(error.message)
    }
  }

  return (
    <ShowComponents onIntersection={apicalls}>
      <Box component={'div'}>
        <Accordion expanded={props.accordionOpen}
          onChange={(_, isExpanded) => {
            props.setAccordionOpen(isExpanded, true);
          }}>
          <AccordionSummary className='doc_notes_header_card' expandIcon={<ExpandMoreIcon />}>
          <Box component={'div'} display={'flex'} justifyContent={'space-between'}>
            <Typography className='doc_notes_header_card_font'>Investigation</Typography>
            <Box component={'div'} display={'flex'}>
              <RadioGroup
                emed_tid='radio'
                row
                value={invest.selectedRadio}
                onChange={(e) => { setInvest((prev) => ({ ...prev, selectedRadio: e.target.value })) }}
              >
                <FormControlLabel value="test" control={<Radio size='small' disabled={props?.props?.patient_transfered || props?.props?.isLocked} />} label={<Typography className='doc_notes_header_card_font'>Test</Typography>} />
                <FormControlLabel value="special" control={<Radio size='small' disabled={props?.props?.patient_transfered || props?.props?.isLocked} />} label={<Typography className='doc_notes_header_card_font'>Special</Typography>} />
              </RadioGroup>
              <Tooltip placement='top' arrow title={'Transfer'}><IconButton className='Common_Btn_Min_Width'
                disabled={invest.investigationData?.every(item => item?.is_transmitted)}
                onClick={() => postInvestigationTransmitData()}
              ><SyncAltIcon color='primary' /></IconButton></Tooltip>
              <Tooltip placement='top' arrow title={'Print'}>
                <IconButton className='Common_Btn_Min_Width' emed_tid='prev_gls_prt'
                  disabled={invest.printLoad}
                  onClick={() => setInvest((prev) => ({ ...prev, printLoad: true }))}
                ><PrintIcon color='primary' /></IconButton></Tooltip>
            </Box>
          </Box>
          </AccordionSummary>
          <AccordionDetails component={'div'} m={'0.5rem'}>
            <Box component={'div'} border={'1px solid lightgray'}>
              <Table size='small'>
                <TableHead>
                  <TableRow>
                    <TableCell className='doc_notes_tbl_header'>Laboratory</TableCell>
                    <TableCell className='doc_notes_tbl_header'>Test Name</TableCell>
                    <TableCell className='doc_notes_tbl_header'>Status</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {invest?.investigationData?.length > 0 ? invest?.investigationData?.map((item, index) => {
                    return (
                      <TableRow key={index}>
                        <TableCell className='doc_notes_tbl_body_cell'>
                          {autocompleteTextBox('lab_name', item?.lab_name, invest?.labList, 'laboratory_name', 'Select Lab', index)}
                        </TableCell>
                        <TableCell className='doc_notes_tbl_body_cell'>
                          {invest.selectedRadio === 'special' ?
                            autocompleteTextBox('special_test_name', item.test_name, invest?.specialData, 'name', 'Special Test', index) :
                            autocompleteTextBox('test_name', item?.test_name, invest?.labTestData, 'test_name', 'Select Test', index)}
                        </TableCell>
                        <TableCell className='doc_notes_tbl_body_cell'>
                          <Box component={'div'} display={'flex'} alignItems={'center'}>
                            <Typography className='doc_notes_header_card_font'>{item?.status}</Typography>
                            <IconButton sx={{ height: COMMON_STYLE.HEIGHT }} emed_tid='dlt_inv'
                              disabled={props?.props?.patient_transfered || props?.props?.isLocked || item?.is_transmitted}
                              onClick={() => { deleteInvestigationData(item, index) }}
                            ><DeleteIcon color={props?.props?.patient_transfered || props?.props?.isLocked ? '' : 'error'} /></IconButton>
                          </Box>
                        </TableCell>
                      </TableRow>
                    )
                  }) : <TableRow><TableCell align='center' colSpan={3}>{COMMON_STYLE.NO_RECORDS}</TableCell></TableRow>}
                </TableBody>
              </Table>
            </Box>
          </AccordionDetails>
        </Accordion>
        {
          message.isErrorMsg ?
            <ToastMsg
              severity={'error'}
              msg={message.isErrorMsgText}
              msgPop={msgClose}
            />
            : null
        }
        {
          message.successMsg ?
            <ToastMsg
              severity={'success'}
              msg={message.successMsgText}
              msgPop={msgClose}
            />
            : null
        }
      </Box >
    </ShowComponents>
  )
})

export default UmaInvestigation